const CDN_HOST = process.env.REACT_APP_CDN_HOST;

export default CDN_HOST?.endsWith('/') ? CDN_HOST : CDN_HOST + '/';
